module.exports = __webpack_public_path__ + "img/neo-icon.3308d913.svg";